import { Navigate } from "react-router-dom";

import { UseGuardStepHook } from "@/hooks/useGuardStep";

export interface GuardedRouteProps {
    useGuardStep: UseGuardStepHook;
    children: React.ReactElement;
}

export function GuardedRoute({ useGuardStep, children }: GuardedRouteProps) {
    const { loading, passThrough, errors, redirect, LoadingComponent } = useGuardStep();

    if (errors.length > 0) {
        console.error("GuardedRoute errors", errors);
    }

    if (loading) {
        if (LoadingComponent) return <LoadingComponent />;
        return null;
    }

    if (redirect) {
        return <Navigate to={redirect ?? ""} replace />;
    }

    if (!passThrough) {
        return null;
    }

    return children;
}
